// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__JPZA2","active":"Navbar_active__l7FQP"};